const SONG_TYPE_DISPLAY_LABELS = new Set(["KK Original", "Commercial"]);

export function isSongTypeDisplayLabel(value: string): boolean {
  return SONG_TYPE_DISPLAY_LABELS.has(value.trim());
}

export function validateKkOriginalHints(title: string, artistName: string): string | null {
  const t = title.trim();
  const a = artistName.trim();
  if (!t || !a) {
    return "Title and artist are required for KK Original uploads.";
  }
  if (isSongTypeDisplayLabel(t)) {
    return "Title must be the song title, not the song type label (KK Original).";
  }
  if (isSongTypeDisplayLabel(a)) {
    return "Artist must be the artist name, not the song type label.";
  }
  return null;
}
